var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KTCodePreview',{attrs:{"title":'Cấu hình cài đặt của nhà phát triển'},scopedSlots:_vm._u([{key:"preview",fn:function(){return [_c('b-table',{attrs:{"items":_vm.configs}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }